export default __webpack_public_path__ + "audio/46307a06b8030c15574123b039c10efc.mp3";